import moment from 'moment';
import React, { useEffect } from 'react'
import { Button, ButtonGroup, Card, Form, Modal, SplitButton, Table } from 'react-bootstrap';
import AdminService from '../../../services/admin.service';
import toast from 'react-hot-toast';
import { FaDownload } from 'react-icons/fa';
import InstantExportModal from '../../../components/Modal/InstantExport.modal';


export default function ExportRequests() {

    const [versions, setVersions] = React.useState<any>([]);
    const [showInstantExport, setShowInstantExport] = React.useState<boolean>(false);

    const getVersions = async () => {
        await AdminService.getExportRequests()
            .then((res) => {
                if (res.status === 200) {
                    console.log(res.data, "exports");
                    setVersions(res.data.exports || []);
                }
            }
            ).catch((err) => {
                console.log(err);
            }
            )
    }


    useEffect(() => {
        getVersions();
    }, [])

    return (
        <>
            <Card>
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <Card.Title className="mb-0">Export Requests</Card.Title>
                    <Button variant="primary" size="sm" onClick={() => setShowInstantExport(true)}>
                        Instant Export
                    </Button>
                </Card.Header>
                <Card.Body>
                    <Table striped bordered hover size="sm">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Type</th>
                                <th>Progress</th>
                                <th>Exam Details</th>
                                <th>Shift Details</th>
                                <th>Requested By</th>
                                <th>Created At</th>
                                <th>Download</th>
                            </tr>
                        </thead>
                        <tbody>
                            {versions && versions.map((items: any, index: number) => {
                                let shift = items?.examId?.shifts?.find((shift: any) => shift?._id === items?.shiftId) || null
                                return (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{items?.type || 'N/A'}</td>
                                        <td>{items?.progress || 'N/A'}</td>
                                        <td>{items?.examId?.name || 'N/A'}
                                            <p style = {{fontSize:"12px"}}>{shift?.shiftName}</p>
                                        </td>
                                        <td>{shift?._id || 'N/A'}
                                            <p style = {{fontSize:"12px"}}>{moment(shift?.startTime).format("DD/MM/YY - hh:mm a")} To  {moment(shift?.endTime).format(" hh:mm a")}</p>
                                        </td>
                                        <td>{items?.requestedBy?.username || 'N/A'}</td>
                                        <td>{moment(items?.createdAt).format("DD-MM-YYYY hh:mm a")}</td>
                                        <td>
                                            {
                                                items?.link ?
                                                    <a href={items?.link} target="_blank" rel="noopener noreferrer">
                                                        <FaDownload />
                                                    </a> :
                                                    "N/A"
                                            }
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            <InstantExportModal
                show={showInstantExport}
                onHide={() => setShowInstantExport(false)}
            />
        </>
    )
}